import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AppButton from "component/button/AppButton";
import PrimaryAuthLayout from "component/primaryAuthLayout/PrimaryAuthLayout";
import TextField from "component/textField/TextField";
import styles from "./SignUp.module.css";
import eye_slash from "assets/images/eye-slash.svg";
import eye from "assets/images/eye.svg";
import Grid from "@mui/material/Unstable_Grid2";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import { useNavigate } from "react-router";
import info_icon from "assets/images/info_icon.svg";
import { signupSchema } from "schemas/auth/AuthSchemas";
import { useSignup } from "api/mutations/auth";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import {
  getResponsiveDocumentModalWidth,
  getResponsiveModalWidth,
} from "utils/helpers";
import Terms from "./modals/terms/Terms";
import ModalLayout from "component/modalLayout/ModalLayout";
import form_icon from "assets/images/application-form-icon.svg";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";
function SignUp() {
  const navigate = useNavigate();
  const [openTerms, setOpenTerms] = useState(false);
  const [width, setWidth] = useState(getResponsiveModalWidth());

  const {
    signUpData,
    loading,
    signUp,
    openModal,
    setOpenModal,
    severity,
    message,
    openToast,
    setOpenToast,
    duration,
  } = useSignup();
  const {
    handleSubmit,
    register,
    reset,
    watch,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signupSchema),
  });
  const [passwordToggler, setPasswordToggler] = useState(true);
  const phone = watch("phone", "");
  const handleGoToVerification = () => {
    navigate("/verification", {
      state: {
        email: signUpData.email,
      },
    });
  };
  useEffect(() => {
    if (phone) {
      trigger("phone");
    }
  }, [phone]);

  useEffect(() => {
    getResponsiveModalWidth();
    window.addEventListener("resize", () => {
      setWidth(getResponsiveModalWidth());
    });
  }, []);

  return (
    <PrimaryAuthLayout>
      <div className={styles.signup}>
        <div className={styles.heading}>
          <Typography variant="h1">Create profile</Typography>
          <Typography>
            Create a profile to begin your mortgage application
          </Typography>
        </div>
        <form onSubmit={handleSubmit(signUp)} className={styles.form}>
          <Grid container spacing={1.5}>
            <Grid xs={12} sm={6}>
              <div className={styles.field}>
                {" "}
                <TextField
                  errors={errors}
                  name="firstName"
                  register={register}
                  required={true}
                  type="text"
                  label="First Name"
                  placeholder="First Name"
                />{" "}
              </div>
            </Grid>
            <Grid xs={12} sm={6}>
              <div className={styles.field}>
                {" "}
                <TextField
                  errors={errors}
                  name="lastName"
                  register={register}
                  required={true}
                  type="text"
                  label="Last Name"
                  placeholder="Last Name"
                />{" "}
              </div>
            </Grid>
            <Grid xs={12} sm={6}>
              <div className={styles.field}>
                {" "}
                <PhoneNumberInput
                  setValue={setValue}
                  name="phone"
                  value={phone}
                  errors={errors}
                />
              </div>
            </Grid>
            {/* <Grid xs={12} sm={12}>
              <div className={styles.field}>
                {" "}
                <TextField
                  errors={errors}
                  name="bvn"
                  register={register}
                  required={true}
                  type="text"
                  label="BVN"
                  placeholder="Insert BVN"
                />{" "}
              </div>
            </Grid> */}
            <Grid xs={12} sm={6}>
              <div className={styles.field}>
                <TextField
                  errors={errors}
                  name="email"
                  register={register}
                  required={true}
                  type="text"
                  label="Email"
                  placeholder="Examplejoe@gmail.com"
                />
              </div>
            </Grid>
            <Grid xs={12} sm={6}>
              <div className={styles.field}>
                <TextField
                  handleAction={() => {
                    setPasswordToggler(!passwordToggler);
                  }}
                  errors={errors}
                  register={register}
                  name="password"
                  required={true}
                  type={passwordToggler ? "password" : "text"}
                  label="Password"
                  placeholder="Insert Password"
                  icon={passwordToggler ? eye_slash : eye}
                />
              </div>
            </Grid>
            <Grid xs={12} sm={12}>
              <div className={`${styles.field} ${styles.extra_field}`}>
                <label>
                  <input {...register("terms")} type="checkbox" name="terms" />
                  <Typography>
                    I consent to Stanbic IBTC Bank's{" "}
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTerms(true);
                      }}
                    >
                      {" "}
                      Terms{" "}
                    </a>
                    &{" "}
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTerms(true);
                      }}
                      href="/"
                    >
                      {" "}
                      Conditions{" "}
                    </a>
                    guiding the use of this platform
                  </Typography>
                </label>
                <ValidationMessage message={errors?.terms?.message} />
              </div>
            </Grid>
            <Grid xs={12} sm={12}>
              <div className={styles.form_btn}>
                <AppButton
                  loading={loading}
                  fullwidth
                  textColor="#FFFFFF"
                  btnBg="#0089FF"
                  btnText="Submit"
                />
              </div>
              <div className={styles.login}>
                <Typography>
                  Already have an account? Proceed to{" "}
                  <Link to="/login">Login</Link>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </form>
        <TTFSnackbar
          severity={severity}
          message={message}
          open={openToast}
          setOpen={setOpenToast}
          duration={duration}
        />
        <AppBackdrop
          openModal={openModal}
          handleCloseModal={() => {}}
          children={
            <AuthModalLayout
              handleClose={() => {
                setOpenModal(false);
                handleGoToVerification();
              }}
              icon={"info"}
              primaryText="Information"
              secondaryText="Check your mailbox, a verification PIN was sent in, copy the code and
            input to continue with your application."
            />
          }
        />
      </div>
      {openTerms && (
        <ModalLayout
          icon={form_icon}
          title="Terms & Conditions"
          handleClose={() => {
            setOpenTerms(false);
          }}
          width={width}
          openModal={openTerms}
          children={<Terms />}
        />
      )}
    </PrimaryAuthLayout>
  );
}

export default SignUp;